module.exports = __webpack_public_path__ + "static/media/WhatIsMentalFitness.e61ac29c.png";